/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export interface IUser {
  id: string;
  idpSubjectId: string;
  realmId: string;
  realmName: string;
  userName: string;
  priority?: number;
  idpId: string;
  isLocalUser?: boolean;
}

export interface IUserDetails {
  id: string;
  idpSubjectId: string;
  realmId: string;
  realmName: string;
  userName: string;
  priority?: number;
  idpId: string;
  email?: string;
  mobilePhone?: string;
  givenName?: string;
  lastName?: string;
  displayName?: string;
  isMfaEnabled?: boolean;
  preferredMfa?: string;
  isAccountEnabled?: boolean;
  isLocalUser?: boolean;
}

export interface INativeUserDetailsProps {
  id: string;
  userName: string;
  handleCopyClick: Function;
}

export interface IUserDetailsProps {
  id: string;
  idpSubjectId: string;
  realmId: string;
  realmName: string;
  userName: string;
  priority?: number;
  idpId: string;
  handleCopyClick: Function;
  isLocalUser?: boolean;
}

export interface IUserList {
  filteredUsers: IUser[];
  handleListItemClick: (listItem: IUser) => void;
  handleManagePopoverContent: (_event: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: string, type: string) => void;
  selectedItem: IUser;
  selectedRowsData: IUser[];
  onSelectedRowsDataChange: (selectedRowsData: IUser[]) => void;
  onChangePageOptions: (itemsPerPage: number, page: number) => void;
  handleDeleteUser: (arg0: IUser, arg1: boolean) => void;
  handleManageRoles: (userId: string) => void;
  handleAssignLocation: (userId: string) => void;
  extendedToolbar?: any;
  loading?: boolean;
}

export interface ISortFields {
  fieldName: string;
  ascending: boolean;
}

export class Page {
  pageCount: number = 1;
  pageNumber: number = 1;
  pageSize: number = 50;
  lastPage: boolean = false;
  count: number = 100;
  sortFields: ISortFields[] = [];
}

export interface IUsers {
  usersList: IUser[],
  page: Page;
}

export interface UserSearch {
  'filter-by-key'?: string;
  'filter-by-value'?: string;
  'filter-by-name'?: string;
  'filter-by-username'?: string;
  'page-number'?: number;
  'page-size'?: number;
  'order-by'?: string;
  'location-id'?: string;
}

export interface IUserRequest {
  userName: string,
  idpId: string
}

export interface INativeUserRequest {
  userName: string,
  idpId: string,
  email: string,
  mobilePhone?: string,
  displayName: string,
  givenName?: string,
  lastName?: string,
  isMfaEnabled?: boolean,
  preferredMfa?: string,
}

export interface INativeUserUpdateRequest {
  email?: string,
  mobilePhone?: string,
  displayName?: string,
  givenName?: string,
  lastName?: string,
  isMfaEnabled?: boolean,
  preferredMfa?: string,
  isAccountEnabled?: boolean
}

export interface IFedratedUserUpdateRequest {
  lastName?: string,
  mobilePhone?: string,
  email?: string,
  displayName?: string,
  isMfaEnabled?: boolean,
  preferredMfa?: string,
  isAccountEnabled?: boolean,
}

export interface IUserPasswordResetResponse {
  password: string;
  idpSubjectId?: string;
}

export interface INativeUserRequestResponse {
  id: string,
  userName: string,
  idpId: string,
  email: string,
  mobilePhone?: string,
  displayName: string,
  givenName?: string,
  lastName?: string,
  isMfaEnabled?: boolean,
  preferredMfa?: string,
  realmId: string,
  realmName: string,
  idpSubjectId: string
  password?: string,
  isAccountEnabled?: boolean
}

export interface IUserRequestResponse {
  id: string,
  userName: string,
  idpId: string,
  realmId: string,
  realmName: string,
  idpSubjectId: string
}

export interface IIDP {
  id: string;
  name: string;
}

export interface IIDPData {
  [x: string]: any;
  idps: IIDP[]
}
